"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatorSetting = void 0;
var ValidatorSetting;

(function (ValidatorSetting) {
  ValidatorSetting["off"] = "off";
  ValidatorSetting["error"] = "error";
  ValidatorSetting["warn"] = "warn";
})(ValidatorSetting = exports.ValidatorSetting || (exports.ValidatorSetting = {})); // export type ValidationConfig = Record<keyof typeof ValidatorID, ValidatorSetting>;